<app-summary-list #summaryList class="p-summary-list--normal-mode" [viewMode]="0"></app-summary-list>
